<template>
    <div class="merchantList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input
                        size
                        clearable
                        v-model="searchForm.nick_name"
                        placeholder="请输入销售名称"
                    ></el-input>
                </el-form-item>
              <el-form-item>
              <el-input
                  size
                  clearable
                  v-model="searchForm.mobile"
                  placeholder="请输入销售账号"
              ></el-input>
              </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="month"
                        placeholder="请选择任务时间"
                        value-format="yyyy-MM"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(searchForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div  style="margin-bottom:20px">
				<el-button size="medium" type="primary"  style="font-size: 12px;"
					@click="addStateClick">添加任务</el-button>
			</div>
            <el-table
                :data="taskList"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <!-- 序号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 销售名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="nick_name"
                    label="销售名称"
                    min-width="120"
                ></el-table-column>
				<!-- 销售账号 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="mobile"
				    label="销售账号"
				    min-width="120"
				></el-table-column>
				<!-- 任务时间 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="date"
				    label="任务时间"
				    min-width="160"
				></el-table-column>
				<!-- 月任务量（台） -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="assignments"
				    label="月任务量（台）"
				    min-width="120"
				></el-table-column>
				<!-- 月出货量（台） -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="shipment"
				    label="月出货量（台）"
				    min-width="120"
				></el-table-column>
				<!-- 出货达标情况 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="reach"
				    label="出货达标情况"
				    min-width="120"
				></el-table-column>
				<!-- 创建时间 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="create_time"
				    label="创建时间"
				    min-width="160"
				></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="160"
                >
                    <template slot-scope="scope">
                      <el-button  @click="cellClick(scope.row,'编辑')" type="text" size="small">编辑</el-button>
					  <el-button  @click="cellClick(scope.row,'标记出货量')" type="text" size="small">标记出货量</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
		
		<el-dialog title="添加任务" :visible.sync="addState" class="dialog">
		  <el-form  label-position="right" :model="addForm" ref="addForm" label-width="120px"  :rules="rules" >
		     <el-form-item label="选择销售:"  prop="person_id">
				<el-select
				  filterable v-model="addForm.person_id" placeholder="请选择销售">
				  <el-option v-for="(item,index) in saleList" :key="item.nick_name" :label="item.nick_name" :value="item.id"></el-option>
				</el-select>
		      </el-form-item>
			  <el-form-item label="任务时间:"  prop="date">
			  	<el-date-picker
			  	    v-model="addForm.date"
			  	    type="month"
			  	    placeholder="请选择任务时间"
			  	    value-format="yyyy-MM"
			  	    @change="pickerChange2"
			  	></el-date-picker>			
			  </el-form-item>
			  <el-form-item label="月任务量："   prop="assignments">
				  <el-col :span="20">
					  <el-input  v-model="addForm.assignments" autocomplete="off"></el-input>	  
				  </el-col>
				  <el-col :span="4">
					  <span style="margin-left: 5px;">台</span>		  					
				  </el-col>		 
			  </el-form-item>
			 
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="addState = false">取 消</el-button>
		    <el-button type="primary" @click="addSubmit()">确 定</el-button>
		  </div>
		</el-dialog>
		
		<el-dialog title="编辑任务" :visible.sync="isEidt" class="dialog">
		  <el-form  label-position="right" :model="addForm" ref="isEidt" label-width="120px"  :rules="rules" >
		     <el-form-item label="选择销售:"  prop="person_id">
				<el-select
				  disabled filterable v-model="addForm.person_id" placeholder="请选择销售">
				  <el-option v-for="(item,index) in saleList" :key="item.nick_name" :label="item.nick_name" :value="item.id"></el-option>
				</el-select>
		      </el-form-item>
			  <el-form-item label="任务时间:"  prop="date">
			  	<el-date-picker
				    disabled
			  	    v-model="addForm.date"
			  	    type="month"
			  	    placeholder="请选择任务时间"
			  	    value-format="yyyy-MM"
			  	    @change="pickerChange2"
			  	></el-date-picker>			
			  </el-form-item>
			  <el-form-item label="月任务量："   prop="assignments">
				  <el-col :span="20">
					  <el-input  v-model="addForm.assignments" autocomplete="off"></el-input>	  
				  </el-col>
				  <el-col :span="4">
					  <span style="margin-left: 5px;">台</span>		  					
				  </el-col>		 
			  </el-form-item>
			 
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="isEidt = false">取 消</el-button>
		    <el-button type="primary" @click="addSubmit()">确 定</el-button>
		  </div>
		</el-dialog>
		
		<el-dialog title="标记出货量" :visible.sync="biaoState" class="dialog">
		  <el-form  label-position="right" :model="addForm" ref="biaoForm" label-width="120px"  :rules="rules" >
		     <el-form-item label="销售名称:"  prop="person_id">
				 <span>{{addForm.nick_name}}</span>
		      </el-form-item>
			  <el-form-item label="任务时间:"  prop="date">
			  	 <span>{{addForm.date}}</span>		
			  </el-form-item>
			  <el-form-item label="月出货量："  prop="shipment">
				  <el-col :span="20">
					  <el-input  v-model="addForm.shipment" autocomplete="off"></el-input>	  
				  </el-col>
				  <el-col :span="4">
					  <span style="margin-left: 5px;">台</span>		  					
				  </el-col>		 
			  </el-form-item>
			 
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="biaoState = false">取 消</el-button>
		    <el-button type="primary" @click="biaoSubmit()">确 定</el-button>
		  </div>
		</el-dialog>
		
    </div>
</template>

<script>
export default {
    name: "salePersonTask",
    data() {
        return {
            searchForm: {
                nick_name: '',
                mobile: '',
                year: '',
				month:'',
				limit:10,
				page: 1
            },
			addState:false,
			biaoState:false,
			addForm:{
				nick_name:'',
				assignments:'',
				person_id:'',
				date:'',
				year:'',
				month:'',
				shipment:'',
				id:''
			},
			rules: {
				person_id: [{
					required: true,
					message: '请选择销售',
					trigger: 'change'
				}],
				date: [{
					required: true,
					message: '请选择任务时间',
					trigger: 'change'
				}],
				assignments: [{
					required: true,
					message: '请输入任务量',
					trigger: 'blur'
				}],
				shipment: [{
					required: true,
					message: '请输入出货量',
					trigger: 'blur'
				}]
			},
            rangeDate: '',
            taskList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
			saleList:[],
			isEidt:false
        }
    },
    mounted() {
       
		this.getSalePersion()
		this.handleDefaultTime()
    },
    methods: {
		handleDefaultTime() { //默认获取三十天
		    this.rangeDate = this.$moment().format('YYYY-MM');
			let arr = this.rangeDate.split('-')
			this.searchForm.year = arr[0]
			this.searchForm.month = arr[1]
			this.getData(this.searchForm);
		},
		// 获取销售
		getSalePersion() {
			this.$api.post("sale/selSalePersonOpt", {}, res => {
			    let data = res.data;
			    this.saleList = res.data;
			})
		},
		
        onSearch(searchFrom) {
            this.currentPage = 1;
            searchFrom.page = 1;
            this.getData(searchFrom);
        },
        getData(params) { //获取数据
            this.loading = true;
			console.log(this.rangeDate);
			if (this.rangeDate == null ||  this.rangeDate == '') {
				this.searchForm.year = ''
				this.searchForm.month = ''
			}
            this.$api.post("sale/taskList", params, res => {
                let data = res.data;
                this.total = data.total; //总数
                this.taskList = res.data.data;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        pickerChange(DateArr) { //时间选择器
			let arr = DateArr.split('-')
			this.searchForm.year = arr[0]
			this.searchForm.month = arr[1]
        },
		pickerChange2(DateArr) { //时间选择器
			let arr = DateArr.split('-')
			this.addForm.year = arr[0]
			this.addForm.month = arr[1]
		},
		cellClick(item,title){
			if (title == '编辑') {
				for (let model of this.saleList) {
					if (model.nick_name == item.nick_name) {
						this.addForm.person_id = model.id
					}
					
				}
				this.addForm.assignments = item.assignments
				this.addForm.date = item.year + '-' + item.month
				this.addForm.year = item.year
				this.addForm.month = item.month
				this.addForm.id = item.task_id
				this.isEidt = true
				
			}else {
				for (let model of this.saleList) {
					if (model.nick_name == item.nick_name) {
						this.addForm.person_id = model.id
						
					}
					
				}
				this.addForm.nick_name = item.nick_name
				this.addForm.date = item.year + '-' + item.month
				this.addForm.year = item.year
				this.addForm.month = item.month
				this.addForm.shipment = item.shipment
				this.biaoState = true
				
			}
		},
		addStateClick(){
			this.addForm.person_id = ''
			this.addForm.assignments = ''
			this.addForm.date = ''
			this.addState = true
		},
		// 标记出货量
		biaoSubmit(){
			this.$refs['biaoForm'].validate((valid) => {
				if (valid) {
					this.loading = true;
					this.$api.post("sale/saveShipment", this.addForm, res => {
					    //渲染结束后取消加载
					    this.loading = false;
						if (res.code == 0) {
							this.biaoState = false
							this.$message.success(res.msg);
							this.getData(this.searchForm);				   
						}else {
							this.$message.error(res.msg);
						}
					})
					
				}
				
			})
		},
		//添加任务量和编辑任务量
		addSubmit(){
			if (this.isEidt) {
				this.$refs['isEidt'].validate((valid) => {
					if (valid) {
						this.loading = true;
						this.$api.post("sale/saveTask", this.addForm, res => {
						    //渲染结束后取消加载
						    this.loading = false;
							if (res.code == 0) {
								this.isEidt = false
								this.$message.success(res.msg);
								this.getData(this.searchForm);				   
							}else {
								this.$message.error(res.msg);
							}
						})	
					}
				})
				
			}else {
				this.$refs['addForm'].validate((valid) => {
					if (valid) {
						this.loading = true;
						this.$api.post("sale/addTask", this.addForm, res => {
						    //渲染结束后取消加载
						    this.loading = false;
							if (res.code == 0) {
								this.addState = false
								this.$message.success(res.msg);
								this.getData(this.searchForm);				   
							}else {
								this.$message.error(res.msg);
							}
						})
							
					}
					
				})
						
			}
		}
    }
}
</script>

<style scoped lang="scss">
.merchantList {
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
}
</style>